import { render, staticRenderFns } from "./UrunListesi.vue?vue&type=template&id=197eb061&scoped=true&"
import script from "./UrunListesi.vue?vue&type=script&lang=js&"
export * from "./UrunListesi.vue?vue&type=script&lang=js&"
import style0 from "./UrunListesi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UrunListesi.vue?vue&type=style&index=1&id=197eb061&lang=scss&scoped=true&"
import style2 from "./UrunListesi.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197eb061",
  null
  
)

export default component.exports